module.exports = __webpack_public_path__ + "c74c264534d912164777c7d273101329.svg";